<mat-card>
  <a>
    <img [ngSrc]="cardImage" width="100"
         height="125" alt="image produit boutique" mat-card-image />
  </a>
  <mat-card-content>
    <mat-card-title>{{ product?.name }}</mat-card-title>
    <div class="wrapper">
      <p>{{ product?.description }}</p>
    </div>
    <p *ngIf="product?.price !== 0; else free">
      {{ product?.price! | price | currency }}
    </p>
    <ng-template #free>
      <p>Gratuit</p>
    </ng-template>
  </mat-card-content>
  <mat-card-actions>
    <button
      (click)="openEditDialog()"
      gaEvent="open_edit_product"
      color="primary"
      data-test="editProduct"
      mat-icon-button
      matTooltip="Mettre à jour le produit"
    >
      <mat-icon>edit</mat-icon>
    </button>

    <button
      gaEvent="preview_download_product"
      (click)="download()"
      color="primary"
      data-test="downloadProduct"
      mat-icon-button
      matTooltip="Télécharger le produit"
    >
      <mat-icon>download</mat-icon>
    </button>
    <button
      (click)="openDeleteDialog()"
      color="warn"
      data-test="deleteProduct"
      mat-icon-button
      matTooltip="Supprimer le produit"
    >
      <mat-icon>delete</mat-icon>
    </button>
    <button color="primary" mat-icon-button>
      <mat-icon *ngIf="!product?.active" matTooltip="Produit non visible"
        >visibility_off
      </mat-icon>
    </button>
  </mat-card-actions>
</mat-card>
